import React from 'react';
import { Link } from "react-router-dom";
import '../css/landing.css';

export default function Seminar() {
    return (
        <div>
            <div className="thank-you-page">
                <div className="thank-you-container">
                    <h1>Ačiū, kad susisiekėte su mumis!</h1>
                    <p className="under-text">Mūsų komanda atsakys į jūsų užklausą kuo greičiau.</p>
                    <Link to="/" className="mainButton">Grįžti į pradinį puslapį.</Link><br />
                </div>
            </div>
        </div>
    )
}